import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import selectors from '../../../../store/shared/selectors'
import renderTextInputWithFeedback from '../../../../components/ui/forms/renderTextInputWithFeedback'
import formValidators from '../../../../utils/validation/formValidators'
import notificationsUtils from '../../../../utils/notifications/notificationsUtils'
import intercom from '../../../../utils/intercom/intercomUtils'
import { currentUserSuccess } from '../../../../store/shared/currentUserDuck'
import { performValidateInsToken } from '../../Onboarding/insTokenDuck'
import { performLogin } from '../loginDuck'
class LoginForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    isPerformingLoginRequest: PropTypes.bool.isRequired,
    showImpersonation: PropTypes.any,
  }

  static defaultProps = {
    showImpersonation: false,
  }

  render() {
    const {
      handleSubmit,
      isPerformingLoginRequest,
      showImpersonation,
    } = this.props

    return (
      <div className="row">
        <div className="col-12 pt-3">
          <form>
            {showImpersonation && (
              <Field
                component={renderTextInputWithFeedback}
                name="impersonatee_email"
                placeholder="Email of Impersonatee"
              />
            )}
            <Field
              component={renderTextInputWithFeedback}
              name="email"
              placeholder="Email"
            />
            <Field
              component={renderTextInputWithFeedback}
              name="password"
              placeholder="Password"
              type="password"
            />
            {isPerformingLoginRequest ? (
              <div className="text-center"> Loading... </div>
            ) : (
              <button
                onClick={handleSubmit}
                className="btn btn-block btn-success"
                disabled={isPerformingLoginRequest}
              >
                Enter
              </button>
            )}
          </form>
        </div>
      </div>
    )
  }
}

/**
 * @const validate
 * @desc Checks whether our form is valid
 * @param values
 * @returns {{}}
 */
const validate = (values) => {
  const errors = {}
  errors.email = formValidators.isRequired(values.email)
  errors.email = formValidators.isAnEmail(values.email)
  errors.password = formValidators.isRequired(values.password)
  return errors
}

/**
 * @const wrappedWithForm
 * @desc Gives SignupForm extra props like invalid, pristine, and handleSubmit
 */
const wrappedWithForm = reduxForm({
  form: 'loginForm',
  onSubmit: async (values, _dispatch, props) => {
    try {
      const { user } = await props.performLogin(values)
      props.currentUserSuccess(user)

      if (user.insToken)
        await props
          .performValidateInsToken({ insToken: user.insToken })
          .then(() => {})
          .catch(() => {})

      if (user.stripe_customer_id) {
        switch (user.info.userType) {
          case 'admin':
            props.history.push('/app/admin')
            break
          case 'parent':
            props.history.push('/app/parent')
            break
          default:
            props.history.push('/app/dashboard')
        }
      } else {
        props.history.push(`/onboarding${props.history.location.search}`)
      }

      // Send user data to intercom
      // Create new hmac whenever we first send the user data
      intercom.createNewHMAC(user._id)
      intercom.intercomBoot({
        user_id: user._id,
        email: user.email,
        createdAt: user.createdAt,
        updatedAt: user.updatedAt,
        insToken: user.insToken,
        stripe_plan_id: user.stripe_plan_id,
        stripe_needs_updated_payment: user.stripe_needs_updated_payment,
        stripe_plan_id_before_cancellation:
          user.stripe_plan_id_before_cancellation,
        ...user.info,
        ...user.profile,
        interests: user.interests.join(', '),
        lastLogin: user.lastLogin,
        accessAllowed: user.accessAllowed,
        isSystemAdministrator: user.isSystemAdministrator,
      })
    } catch (error) {
      notificationsUtils.showErrorNotification(error.message)
    }
  },
  validate,
})(LoginForm)

/**
 * @const makeMapStateToProps
 * @param state
 */
const makeMapStateToProps = () => {
  const isPerformingRequest = selectors.makeGetIsPerformingRequest()
  return (state) => ({
    isPerformingLoginRequest: isPerformingRequest(state, 'login'),
  })
}

/**
 * @const mapDispatchToProps
 * @desc Binds an Action Performer to this.props
 * @param dispatch
 */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      currentUserSuccess,
      performLogin,
      performValidateInsToken,
    },
    dispatch,
  )

export default connect(
  makeMapStateToProps,
  mapDispatchToProps,
)(withRouter(wrappedWithForm))



// WEBPACK FOOTER //
// ./src/routes/unauthenticated/Login/components/LoginForm.js